import PropTypes from 'prop-types';

export const iconProptypesBase = {
  iconColor: PropTypes.string,
};
